import axios from 'axios';

const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');

export const SERVER_URL = trimTrailingSlash(process.env.REACT_APP_API_BASE_URL);
export const ASSET_BASE_URL = trimTrailingSlash(process.env.REACT_APP_ASSET_BASE_URL || process.env.REACT_APP_API_BASE_URL);

if (!SERVER_URL) {
    // CRA embeds env values at build time, so this should be fixed before building.
    console.error('Missing REACT_APP_API_BASE_URL in .env');
}

const api = axios.create({
    baseURL: SERVER_URL + '/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Add a request interceptor to include the token in headers
api.interceptors.request.use(
    (config) => {
        if (config.skipAuth) {
            delete config.headers.Authorization;
            return config;
        }

        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Add a response interceptor to handle 401 errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const errorCode = error.response?.data?.error || error.response?.data?.code;

        if (status === 401 || (status === 403 && errorCode === 'check_app_user_active_failed')) {
            localStorage.removeItem('token');
        }

        return Promise.reject(error);
    }
);

export const login = (email, password, line_id_token = null) => api.post('/login', { email, password, app_type: 'cleaning_app', line_id_token });
export const checkLineAuth = (line_id_token) => api.post('/auth/line-check', { line_id_token }, { skipAuth: true });
export const registerLineUser = (data) => api.post('/line/register', data, { skipAuth: true });
export const checkDingTalkAuth = (auth_code) => api.post('/auth/dingtalk-check', { auth_code }, { skipAuth: true });
export const confirmDingTalkAuth = (confirm_token) => api.post('/auth/dingtalk-confirm', { confirm_token }, { skipAuth: true });
export const register = (data) => api.post('/register', data);
export const logout = () => api.post('/logout');
export const getUser = () => api.get('/user');
export const changePassword = (data) => api.post('/change-password', data);

export const getTasks = (status) => api.get('/tasks', { params: { status } });
export const getTask = (id) => api.get(`/tasks/${id}`);
export const toggleItem = (taskId, itemId) => api.post(`/tasks/${taskId}/items/${itemId}/toggle`);
export const uploadPhoto = (taskId, itemId, formData) => api.post(`/tasks/${taskId}/items/${itemId}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
});
export const deletePhoto = (taskId, itemId) => api.delete(`/tasks/${taskId}/items/${itemId}/photo`);
export const submitTask = (taskId, cleaner_remarks) => api.post(`/tasks/${taskId}/submit`, { cleaner_remarks });

export const getWarehouses = () => api.get('/inventory/warehouses');
export const getInventory = (warehouseId) => api.get('/inventory', { params: { warehouse_id: warehouseId } });
export const consumeInventory = (id, quantity, remarks) => api.post(`/inventory/${id}/consume`, { quantity, remarks });
export const restockInventory = (id, quantity, remarks) => api.post(`/inventory/${id}/restock`, { quantity, remarks });

export const getWarehouseScheduleMe = ({ signal } = {}) => api.get('/warehouse-schedule/me', { signal });
export const getWarehouseScheduleAvailability = (weekStart, warehouseId, { signal } = {}) => api.get('/warehouse-schedule/me/availability', {
    params: { weekStart, warehouseId },
    signal,
});
export const saveWarehouseScheduleAvailability = ({ weekStart, warehouseId, days }, { signal } = {}) => api.post('/warehouse-schedule/me/availability', {
    weekStart,
    warehouseId,
    days,
}, { signal });
export const getWarehouseScheduleAssignments = (weekStart, { signal } = {}) => api.get('/warehouse-schedule/me/schedule', {
    params: { weekStart },
    signal,
});



export default api;
